import React, { useEffect, useState } from 'react';
import { Modal, Button } from './ui';
import { OOORequest } from '../types';
interface RequestFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: Partial<OOORequest>) => void;
  initialData?: OOORequest | null;
}
export function RequestFormModal({
  isOpen,
  onClose,
  onSubmit,
  initialData
}: RequestFormModalProps) {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [message, setMessage] = useState('');
  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        setStartDate(initialData.startDate);
        setEndDate(initialData.endDate);
        setMessage(initialData.message);
      } else {
        setStartDate('');
        setEndDate('');
        setMessage('');
      }
    }
  }, [isOpen, initialData]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      startDate,
      endDate,
      message
    });
  };
  const isFormValid = startDate && endDate && message.trim().length > 0;
  return <Modal isOpen={isOpen} onClose={onClose} title={initialData ? 'Edit Out of Office Request' : 'Create Out of Office Request'} footer={<>
          <Button variant="neutral" onClick={onClose} data-id="element-205">
            Cancel
          </Button>
          <Button variant="brand" onClick={handleSubmit} disabled={!isFormValid} data-id="element-206">
            {initialData ? 'Save Changes' : 'Create Request'}
          </Button>
        </>} data-id="element-204">
      <form id="request-form" onSubmit={handleSubmit} className="space-y-4" data-id="element-207">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-208">
          <div className="space-y-1" data-id="element-209">
            <label className="block text-sm font-medium text-gray-700" data-id="element-210">
              Start Time <span className="text-red-500" data-id="element-211">*</span>
            </label>
            <input type="datetime-local" required value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded shadow-sm focus:outline-none focus:ring-1 focus:ring-[#0176d3] focus:border-[#0176d3] sm:text-sm" data-id="element-212" />
          </div>
          <div className="space-y-1" data-id="element-213">
            <label className="block text-sm font-medium text-gray-700" data-id="element-214">
              End Time <span className="text-red-500" data-id="element-215">*</span>
            </label>
            <input type="datetime-local" required value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded shadow-sm focus:outline-none focus:ring-1 focus:ring-[#0176d3] focus:border-[#0176d3] sm:text-sm" data-id="element-216" />
          </div>
        </div>

        <div className="space-y-1" data-id="element-217">
          <label className="block text-sm font-medium text-gray-700" data-id="element-218">
            Message <span className="text-red-500" data-id="element-219">*</span>
          </label>
          <textarea required rows={4} value={message} onChange={e => setMessage(e.target.value)} placeholder="Please provide a reason or additional details..." className="w-full px-3 py-2 border border-gray-300 rounded shadow-sm focus:outline-none focus:ring-1 focus:ring-[#0176d3] focus:border-[#0176d3] sm:text-sm resize-none" data-id="element-220" />
        </div>
      </form>
    </Modal>;
}